//View Keys
export default {
  maputilities_vehiclelist_visible_groups: 'Administrar Las Etiquetas Visibles',
  maputilities_vehiclelist_no_items: "La Etiqueta no tiene Vehículos",
  maputilities_vehiclelist_no_click_option: "El vehículo aún no tiene las coordenadas",
  maputilities_vehiclelist_follow_unit: "Seguir",
  maputilities_vehiclelist_showAll: "Mostrar Todos",
  maputilities_vehiclelist_hiddenAll: "Ocultar Todos",
};